import React, { Component } from 'react';
import { Button, DatePicker } from 'antd';
import SelectProvince from '../../common/SelectProvince';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        searchParams: {
            date: moment().format(monthFormat),
        },
        areaParams: {},
        hasCheckedArea: [],
        areaName: [],
        maxDate: '',
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    search = () => {
        const { areaParams, searchParams,areaChooseAry,areaName,hasCheckedArea } = this.state;
        this.props.search({ ...searchParams, ...areaParams, areaChooseAry,areaName,hasCheckedArea });
    }

    export = () => {
        const { areaParams, searchParams,areaChooseAry } = this.state;
        this.props.export({ ...searchParams, areaParams,areaChooseAry });
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            const maxDate = date ? date.slice(0, 7) : '';
            this.setState({ maxDate }, () => {
                this.search();
            });
        });
    }

    handleDateChange = (data, dateString) => {
        const { searchParams } = this.state;
        searchParams.date = dateString;
        this.setState({ searchParams });
    }

    saveProvince = (checkedArea) => {
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);

        let areaChooseAry=[];//选择城市或省份时的区域
        checkedArea.map((item, index) => {
          const{area}=item.props;
          const{key}=item;
          const ifChooseProvinceOrCity = ((key.indexOf('CITY') > -1)||(key.indexOf("AREAPROVINCE")>-1));
         
          if(area&&ifChooseProvinceOrCity){
            const begin = area.indexOf('_') + 1;
            const last = area.length;
            const areaId = area.substring(begin, last);
            areaChooseAry.push(Number(areaId));           
          }        
        });
        console.log(areaChooseAry.reduce((prev,cur) => prev.includes(cur) ? prev : [...prev,cur],[]) );
        this.setState({
            areaParams,
            hasCheckedArea,
            areaName: areaList.join(','),
        });
        this.props.setChooseArea(areaChooseAry);
    }

    render() {
        const {
            searchParams: {
                date,
            },
            maxDate,
            areaName,
            hasCheckedArea,
        } = this.state;
        return (
            <div className="filter-bar">
                <div className="filter-bar-investigation">
                    <div className="form-item">
                        <label className="ui-label">时间</label>
                        <MonthPicker
                            style={{width: 90}}
                            format={monthFormat}
                            value={date ? moment(date) : null}
                            placeholder="请选择"
                            allowClear={false}
                            onChange={this.handleDateChange}
                            className="w-90-select"
                            disabledDate={current => current.valueOf() > moment(maxDate).valueOf() }
                        />
                    </div>
                    <div className="form-item">
                        <label className="ui-label">区域/城市</label>
                        <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                    </div>
                    <div className="form-item">
                        <Button type="primary" onClick={this.export}>导出</Button>
                        <Button type="primary" onClick={this.search}>搜索</Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/user/areaCityAnalysis/Filter.js